import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Layout from "../components/Layout";
import images from "../common/images";
import { useQuery } from "@tanstack/react-query";
import ApiCall from "../services/apiCall";
import Hero from "../components/Hero";

const ResetPassword = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState();
  const [createPassword, setCreatePassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { value, otp } = location.state || {};

  const resetPassApi = async () => {
    const minPasswordLength = 6;
    if (createPassword.length < minPasswordLength) {
      toast.error(
        `Invalid password, It must be at least ${minPasswordLength} characters long.`
      );
      return;
    }
    if (createPassword === newPassword) {
      let data = {
        email: value,
        otp: otp,
        password: newPassword,
      };
      try {
        const res = await ApiCall(
          "api/reset-password",
          "POST",
          JSON.stringify(data)
        );
        if (res.ok) {
          toast.success(
            typeof res?.message === "string"
              ? res?.message
              : "Something went wrong"
          );

          navigate("/signin");
        }
      } catch (error) {
        toast.error(error?.message);
      }
    } else {
      toast.error(`Invalid password, Please make sure the passwords match.`);
    }
  };

  return (
    <Layout>
      <Hero title="Forgot Password" />
      {/* Login Section */}
      <section
        className="login-section section-gap wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="midd-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-sec">
                <h2 className="title-30 wow fadeInUp" data-wow-delay="0.2s">
                  Forgot Password
                </h2>
              </div>
              <div className="form-sec">
                <form
                  className="wow fadeInUp"
                  data-wow-delay="0.2s"
                  onSubmit={(e) => {
                    e.preventDefault();
                    resetPassApi();
                  }}
                >
                  <div className="input-sec">
                    <input
                      type={showPassword ? "text" : "password"}
                      name={"password"}
                      placeholder={"Enter New Password"}
                      className="form-control"
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setCreatePassword(inputValue);
                      }}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      <i className={showPassword ? "fas fa-eye" : "fas fa-eye-slash"}></i>
                    </button>
                  </div>
                  <div className="input-sec mt-4">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name={"confirm-password"}
                      placeholder={"Confirm New Password"}
                      className="form-control"
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setNewPassword(inputValue);
                      }}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={
                        showConfirmPassword ? "Hide password" : "Show password"
                      }
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    >
                      <i
                        className={
                          showConfirmPassword ? "fas fa-eye" : "fas fa-eye-slash"
                        }
                      ></i>
                    </button>
                  </div>
                  <div className="btn-sec">
                    <button
                      type="button"
                      className="btn"
                      onClick={resetPassApi}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Login Section End */}
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
      <ToastContainer />
    </Layout>
  );
};

export default ResetPassword;
